import React from "react";
import RoomAssignForm from "../Components/AssignRoomForm";
import { useNavigate } from "react-router-dom";
import fields from "../json/RoomAssignField.json";
import useFormChange from "Hooks/useFormChange";
import { AssignRoomTypeToRoom } from "validation/ValidationRules";
import { validateForm } from "utils/validation";
import useFormSubmit from "Hooks/useFormSubmit";
import { AssignRoomType } from "adminApi/AssignRoomApi/AssignRoom";

const AssignRoom = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(
        initialValues,
        AssignRoomTypeToRoom
    );

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => await AssignRoomType({ data: formValues }),
        (vals) => {
            const err = validateForm(vals, AssignRoomTypeToRoom);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Room assigned successfully"
    );

    return (
        <div className="col-12">
            <RoomAssignForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                setValues={setValues}
                title="Assign Room"
            />
        </div>
    );
};

export default AssignRoom;
